import * as z from "zod";

export const getTaxIdRequirements = {
  name: "getTaxIdRequirements" as const,
  input: z.null(),
  output: z.object({
    /** Whether the team has any return lanes at all, so the UI can tell "no lanes
     * configured" from "lanes configured, none need a tax ID". */
    hasLanes: z.boolean(),
    /** One entry per return lane that needs a tax ID; lanes needing none are omitted. */
    lanes: z.array(
      z.object({
        originCountry: z.string(),
        destinationCountry: z.string(),
        requirements: z.array(
          z.object({
            taxIdType: z.enum(["EORI", "VAT", "EIN"]),
            issuingAuthority: z.string(),
            /** Whether the label path would find a number for this slot. */
            satisfied: z.boolean(),
          }),
        ),
      }),
    ),
  }),
};
